import { darkTheme, lightTheme } from '../../../theme/theme';
import { ThemeType } from '../../../theme/themeType';

const buildMapStyles = (theme: ThemeType): google.maps.MapTypeStyle[] => [
  { elementType: 'geometry', stylers: [{ color: theme.map.commonGeometry }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: theme.map.commonGeometry }] },
  { elementType: 'labels.text.fill', stylers: [{ color: theme.map.commonTextFill }] },
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [{ color: theme.map.administrative }],
  },
  {
    featureType: 'administrative.country',
    elementType: 'labels.text.fill',
    stylers: [{ color: theme.map.administrativeCountry }],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{ color: theme.map.administrativeText }],
  },
  {
    featureType: 'administrative.land_parcel',
    stylers: [{ visibility: 'off' }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: theme.map.park }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: theme.map.parkText }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{ color: theme.map.road }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: theme.map.roadText }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: theme.map.highWay }],
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry',
    stylers: [{ color: theme.map.highWayControlled }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{ color: theme.map.roadArterial }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{ color: theme.map.roadLocal }],
  },
  {
    featureType: 'transit',
    elementType: 'labels.text.fill',
    stylers: [{ color: theme.map.transit }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: theme.map.water }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: theme.map.waterText }],
  },
];

const darkStyles = buildMapStyles(darkTheme);
const lightStyles = buildMapStyles(lightTheme);

export { darkStyles, lightStyles };
